'use client';

import { Suspense } from 'react'
import Sidebar from 'components/common/Sidebar';
import ProtectedRoute from '@/components/auth/ProtectedRoute';

export default function Layout({
    children,
}: Readonly<{ children: React.ReactNode; }>) {
    return (
        <ProtectedRoute data-component-id="src/components/Layout.tsx:11:8" data-component-path="src/components/Layout.tsx" data-component-line="11" data-component-file="Layout.tsx" data-component-name="ProtectedRoute" data-component-content="%7B%22elementName%22%3A%22ProtectedRoute%22%7D">
            <Suspense>
                <main data-component-id="src/components/Layout.tsx:13:16" data-component-path="src/components/Layout.tsx" data-component-line="13" data-component-file="Layout.tsx" data-component-name="main" data-component-content="%7B%22elementName%22%3A%22main%22%2C%22className%22%3A%22w-full%20min-h-screen%20bg-third%22%7D" className="w-full min-h-screen bg-third">
                    <Sidebar data-component-id="src/components/Layout.tsx:14:20" data-component-path="src/components/Layout.tsx" data-component-line="14" data-component-file="Layout.tsx" data-component-name="Sidebar" data-component-content="%7B%22elementName%22%3A%22Sidebar%22%7D" />
                    <div data-component-id="src/components/Layout.tsx:15:20" data-component-path="src/components/Layout.tsx" data-component-line="15" data-component-file="Layout.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22lg%3Aml-%5B264px%5D%20transition-all%20duration-300%22%7D" className="lg:ml-[264px] transition-all duration-300">
                        {children}
                    </div>
                </main>
            </Suspense>
        </ProtectedRoute>
    )
}